import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';

@Component({
  selector: 'app-adsense',
  templateUrl: './adsense.component.html',
  styleUrls: ['./adsense.component.css']
})
export class AdsenseComponent implements AfterViewInit {

  @Input() adSlot: string = '';
  @Input() adFormat: string = 'auto';
  @Input() fullWidth: boolean = true;
  @Input() layoutKey: string = '';

  // Usamos ViewChild para tener una referencia segura al elemento en el DOM
  @ViewChild('adContainer', { static: false }) adContainer!: ElementRef;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Un pequeño delay para asegurar que Angular terminó de pintar el contenedor
      setTimeout(() => {
        this.injectAdsense();
      }, 300);
    }
  }

  private injectAdsense(): void {
    try {
      const container = this.adContainer.nativeElement;

      // Verificamos que el contenedor no tenga ya un anuncio (evita duplicados)
      if (container.children.length > 0) return;

      // 1. Crear el elemento <ins> manualmente
      const ins = document.createElement('ins');
      ins.className = 'adsbygoogle';
      ins.style.display = 'block';
      ins.setAttribute('data-ad-client', 'ca-pub-2782605666423472'); // TU ID DE EDITOR
      ins.setAttribute('data-ad-slot', this.adSlot);
      ins.setAttribute('data-ad-format', this.adFormat);
      ins.setAttribute('data-ad-layout-key', this.layoutKey);
      ins.setAttribute('data-full-width-responsive', this.fullWidth.toString());

      // 2. Insertarlo en el DOM
      container.appendChild(ins);

      // 3. Ejecutar el .push() de la librería que cargó GTM
      (window as any).adsbygoogle = (window as any).adsbygoogle || [];
      (window as any).adsbygoogle.push({});

      console.log(`AdSense inicializado en slot: ${this.layoutKey}`);
    } catch (e) {
      console.error('Error al inyectar AdSense:', e);
    }
  }
}
